import { render, staticRenderFns } from "./CompareBanksModal.vue?vue&type=template&id=cee5a5c2"
import script from "./CompareBanksModal.vue?vue&type=script&lang=js"
export * from "./CompareBanksModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports